import { createRef, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function HTMLComment(_ref) {
  var text = _ref.text;
  var ref = /*#__PURE__*/createRef();
  useEffect(function () {
    var el = null;
    var parent = null;
    var comm = null;
    if (ref.current) {
      el = ref.current;
      parent = el.parentNode;
      comm = document.createComment(" ".concat(text.trim(), " "));
      try {
        if (parent && parent.contains(el)) {
          parent.replaceChild(comm, el);
        }
        // eslint-disable-next-line
      } catch (_unused) {}
    }
    return function () {
      if (parent && el && comm) {
        parent.replaceChild(el, comm);
      }
    };
  }, [ref, text]);
  return /*#__PURE__*/_jsx("span", {
    ref: ref,
    style: {
      display: 'none'
    }
  });
}